import { validateEmail } from "../Login/Validation";

type data = {
  name: string;
  type: string;
  email: string;
  countryCode: string;
  phoneNumber: string;
  info: string;
  whatsappNumber: string;
  instaLink: string;
  fbLink: string;
  lat: string;
  long: string;
  address: string;
  iframe_url: string;
  tripAdvisor: string;
  logoUrl: string[];
  imageUrl: string[];
  masterName: string;
  masterEmail: string;
  bankName: string;
  accountNumber: string;
  legalEntity: string;
  sapCode: string;
  disclaimer: string;
  tc: string;
  segrateTimeSlot: string;
};

export const validatePark = (
  data: data,
  setError: (a: any) => void,
  time: any
) => {
  let isError = false;
  if (data.name === "") {
    setError((prevState: any) => ({
      ...prevState,
      name: "Please enter name",
    }));
    isError = true;
  }
  if (data.type === "") {
    setError((prevState: any) => ({
      ...prevState,
      type: "Please select type",
    }));
    isError = true;
  }
  if (data.email && !validateEmail(data.email)) {
    setError((prevState: any) => ({
      ...prevState,
      email: "Please enter valid email",
    }));
    isError = true;
  }
  if (data.phoneNumber && !checkIsPhoneNumber(data.phoneNumber)) {
    setError((prevState: any) => ({
      ...prevState,
      phoneNumber: "Please enter valid phone number",
    }));
    isError = true;
  }
  if (data.info === "") {
    setError((prevState: any) => ({
      ...prevState,
      info: "Please enter information",
    }));
    isError = true;
  }
  if (data.lat === "") {
    setError((prevState: any) => ({
      ...prevState,
      lat: "Please add lat",
    }));
    isError = true;
  } else if (!isValidLat(data.lat)) {
    setError((prevState: any) => ({
      ...prevState,
      lat: "Please add valid latitude",
    }));
    isError = true;
  }
  if (data.long === "") {
    setError((prevState: any) => ({
      ...prevState,
      long: "Please add long",
    }));
    isError = true;
  } else if (!isValidLng(data.long)) {
    setError((prevState: any) => ({
      ...prevState,
      long: "Please add valid longitude",
    }));
    isError = true;
  }
  if (data.address === "") {
    setError((prevState: any) => ({
      ...prevState,
      address: "Please enter address",
    }));
    isError = true;
  }

  if (data.segrateTimeSlot && isNaN(Number(data.segrateTimeSlot))) {
    setError((prevState: any) => ({
      ...prevState,
      segrateTimeSlot: "Slot duration should be in minutes",
    }));
    isError = true;
  }

  // if (data.disclaimer === "") {
  //   setError((prevState: any) => ({
  //     ...prevState,
  //     disclaimer: "Please enter disclaimer",
  //   }));
  //   isError = true;
  // }

  if (data.logoUrl.length === 0) {
    setError((prevState: any) => ({
      ...prevState,
      logoUrl: "Please upload logo",
    }));
    isError = true;
  }
  if (data.imageUrl.length === 0) {
    setError((prevState: any) => ({
      ...prevState,
      imageUrl: "Please upload images (Maximum 4)",
    }));
    isError = true;
  }
  if (data.whatsappNumber && !checkIsPhoneNumber(data.whatsappNumber)) {
    setError((prevState: any) => ({
      ...prevState,
      whatsappNumber: "Please enter valid phone number",
    }));
    isError = true;
  }
  if (data.instaLink && !urlValidation(data.instaLink)) {
    setError((prevState: any) => ({
      ...prevState,
      instaLink: "Please enter valid instagram URL",
    }));
    isError = true;
  }
  if (data.fbLink && !urlValidation(data.fbLink)) {
    setError((prevState: any) => ({
      ...prevState,
      fbLink: "Please enter valid facebook URL",
    }));
    isError = true;
  }
  if (data.tripAdvisor && !urlValidation(data.tripAdvisor)) {
    setError((prevState: any) => ({
      ...prevState,
      tripAdvisor: "Please enter valid trip advisor URL",
    }));
    isError = true;
  }

  if (data.masterEmail && !validateEmail(data.masterEmail)) {
    setError((prevState: any) => ({
      ...prevState,
      masterEmail: "Please enter valid master email",
    }));
    isError = true;
  }

  if (data.iframe_url && !urlValidation(data.iframe_url)) {
    setError((prevState: any) => ({
      ...prevState,
      iframe_url: "Please enter valid URL",
    }));
    isError = true;
  }

  //
  if (time.type === "single") {
    if (time["timeSingle"].start === "" || time["timeSingle"].end === "") {
      setError((prevState: any) => ({
        ...prevState,
        timeSingle: "Start & End time is required",
      }));
      isError = true;
    }
    // if (time["timeSingle"].start > time["timeSingle"].end) {
    //   setError((prevState: any) => ({
    //     ...prevState,
    //     timeSingle: "End time should be before start",
    //   }));
    //   isError = true;
    // }
    setError((prevState: any) => ({
      ...prevState,
      time: {
        mon: "",
        tue: "",
        wed: "",
        thu: "",
        fri: "",
        sat: "",
        sun: "",
      },
    }));
  } else if (time.type === "multi") {
    setError((prevState: any) => ({
      ...prevState,
      type: "",
    }));

    let timeError = {
      mon: "",
      tue: "",
      wed: "",
      thu: "",
      fri: "",
      sat: "",
      sun: "",
    };
    Object.keys(time.timeMulti).map((key) => {
      if (time.timeMulti[key].start && time.timeMulti[key].end === "") {
        // @ts-ignore
        timeError[key] = "End time is required";
      }
      if (time.timeMulti[key].end && time.timeMulti[key].start === "") {
        // @ts-ignore
        timeError[key] = "Start time is required";
      }
      // if (time.timeMulti[key].start !== "00:00" && (time.timeMulti[key].end === time.timeMulti[key].start)) {
      //   // @ts-ignore
      //   timeError[key] = "Start time is required";
      // }
      // if (time.timeMulti[key].start > time.timeMulti[key].end) {
      //   // @ts-ignore
      //   timeError[key] = "End time should be before start";
      // }
    });

    let isEmpty = Object.values(timeError).every((x) => x === null || x === "");

    if (!isEmpty) {
      setError((prevState: any) => ({
        ...prevState,
        time: { ...timeError },
      }));
      isError = true;
    }
  } else {
    setError((prevState: any) => ({
      ...prevState,
      timeType: "Please select visiting hours type",
    }));
    isError = true;
  }
  //

  return isError;
};

const checkIsPhoneNumber = (data: string) => {
  return /^\+?[0-9]{5,16}$/.test(data);
};

const isValidLat = (value: string) => {
  if (Number(value) >= -90 && Number(value) <= 90) {
    return true;
  }
};

const isValidLng = (value: string) => {
  if (Number(value) >= -180 && Number(value) <= 180) {
    return true;
  }
};

export const urlValidation = (data: string) => {
  // eslint-disable-next-line no-useless-escape
  return /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/.test(
    data
  );
};

export const validateDynamicPromotionData = (
  data: any,
  setError: (a: any) => void,
  promoType: string
): boolean => {
  let isError = false;
  setError({});

  if (!promoType) {
    setError((prev: any) => ({
      ...prev,
      promoType: "Please select promotion type",
    }));
    isError = true;
    return isError;
  }

  if (data.startDate === "") {
    setError((prev: any) => ({
      ...prev,
      startDate: "Start date is required",
    }));
    isError = true;
  }

  if (data.endDate === "") {
    setError((prev: any) => ({
      ...prev,
      endDate: "End date is required",
    }));
    isError = true;
  }

  switch (promoType) {
    case "dynamicProductDiscount":
      if (!data.promoCode) {
        setError((prev: any) => ({
          ...prev,
          promoCode: "Promo code is required",
        }));
        isError = true;
      }
      if (!data.discountPercentage) {
        setError((prev: any) => ({
          ...prev,
          discountPercentage: "Discount percentage is required",
        }));
        isError = true;
      }
      if (
        !Array.isArray(data.products) ||
        data.products.filter((prd: any) => prd.selected).length === 0
      ) {
        setError((prev: any) => ({
          ...prev,
          products: "At least one product must be selected",
        }));
        isError = true;
      }
      break;

    case "dynamicProductPriceDiscount":
      if (!data.promoCode) {
        setError((prev: any) => ({
          ...prev,
          promoCode: "Promo code is required",
        }));
        isError = true;
      }
      if (data.discountedPrice === "" || isNaN(Number(data.discountedPrice))) {
        setError((prev: any) => ({
          ...prev,
          discountedPrice: "Valid discounted price is required",
        }));
        isError = true;
      }
      if (
        !Array.isArray(data.products) ||
        data.products.filter((prd: any) => prd.selected).length === 0
      ) {
        setError((prev: any) => ({
          ...prev,
          products: "At least one product must be selected",
        }));
        isError = true;
      }
      break;

    case "specialDiscount":
      if (!data.promoCode) {
        setError((prev: any) => ({
          ...prev,
          promoCode: "Promo code is required",
        }));
        isError = true;
      }
      if (!data.discountPercentage) {
        setError((prev: any) => ({
          ...prev,
          discountPercentage: "Discount percentage is required",
        }));
        isError = true;
      }
      break;

    case "dynamicPromotion":
      if (
        !Array.isArray(data.products) ||
        data.products.filter((prd: any) => prd.selected).length === 0
      ) {
        setError((prev: any) => ({
          ...prev,
          products: "At least one product must be selected",
        }));
        isError = true;
      }

      if (!Array.isArray(data.details) || data.details.length === 0) {
        setError((prev: any) => ({
          ...prev,
          details: "At least one detail (minQty/freeQty) is required",
        }));
        isError = true;
      } else {
        const detailErrors: any[] = [];

        data.details.forEach((item: any, index: number) => {
          const err: any = {};
          if (!item.minQty || item.minQty <= 0) {
            err.minQty = "Min quantity must be > 0";
            isError = true;
          }
          if (!item.freeQty || item.freeQty <= 0) {
            err.freeQty = "Free quantity must be > 0";
            isError = true;
          }
          detailErrors[index] = err;
        });

        if (detailErrors.some((e) => Object.keys(e).length > 0)) {
          setError((prev: any) => ({
            ...prev,
            details: detailErrors,
          }));
        }
      }
      break;

    default:
      setError((prev: any) => ({
        ...prev,
        promoType: "Invalid promotion type",
      }));
      isError = true;
      break;
  }

  return isError;
};
